import React, { ReactNode, useEffect, useState } from "react";
import { imageGallery as listingStayImageGallery } from "./constant";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
// import BackgroundSection from "components/BackgroundSection/BackgroundSection";
// import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
// import MobileFooterSticky from "./MobileFooterSticky";
// import { requestAPI } from "utils/api";

const DetailPagetLayout = ({ id, children }: { id: undefined | string, children: ReactNode }) => {
	
	const navigate = useNavigate();
	const thisPathname = useLocation().pathname;
	const [searchParams] = useSearchParams();
	const modal = searchParams?.get("modal");

 
	const handleCloseModalImageGallery = () => {
		let params = new URLSearchParams(document.location.search);
		params.delete("modal");
		navigate(`${thisPathname}/?${params.toString()}`);
	};

	const getImageGalleryListing = () => {
		if (thisPathname?.includes("/listing-stay-detail")) {
			return listingStayImageGallery;
		}

		return [];
	};

	return (
		<div className="ListingDetailPage">
			
			
			{/* <ListingImageGallery
				isShowModal={modal === "PHOTO_TOUR_SCROLLABLE"}
				onClose={handleCloseModalImageGallery}
				images={getImageGalleryListing()}
			/> */}

			<div className="container ListingDetailPage__content lg:w-[768px] !p-0">{children}</div>

			{/* OTHER SECTION */}
			{/* <div className="container py-24"> */}
				{/* <div className="relative py-16">
					<BackgroundSection />
					
					<SectionSliderNewCategories
					heading="Explore by types of stays"
					subHeading="Explore houses based on 10 types of stays"
					categoryCardType="card5"
					itemPerRow={5}
					sliderStyle="style2"
					uniqueClassName="ListingDetailPage"
					/>
				</div> */}
				{/* <SectionSubscribe2 className="pt-24 lg:pt-32" /> */}
			{/* </div> */}

			
		</div>
	);
};

export default DetailPagetLayout;
